module.exports = __webpack_public_path__ + "9d6e810be4bd9629d4778b24fd3a3bd7.jpg";